<template>
  <div class="score_record">
    <h2>{{$t('score.score_detail')}}</h2>
      <div class="score_block" v-for="(item,index) in score_detail_list" :key="index">
        <div style="width: 200px">
          <div>{{item.create_time |timeFilter}}</div>
          <div >{{ $t('score_item_map.'+item.type)}}</div>
        </div>

        <div style="width: 30px;margin-right: 10px"> + {{item.integral}}</div>
      </div>
  </div>
</template>

<script>
  import { query_integrals} from "../api/integrals";
import moment from "moment"
  export default {
    name: "scoreDetail",
    data() {
      return {
        score_detail_list: []
      }
    },
    filters:{
      timeFilter(time){
        return moment(time).format("YY-MM-DD HH:mm:ss")
      }
    },
    mounted() {
      let params = {
        page_index: 1,
        page_size: 9999
      }
      query_integrals(params).then(res => {
        this.score_detail_list = res.body
      })


    }
  }
</script>

<style lang="less" scoped>
  .score_record {
    user-select: none;
    padding: 10px;
    z-index: 1000;
    background: black;
    height: 1100px;
    overflow-y: scroll;
    padding-bottom: 30px;

    .score_block {
      border: 2px solid white;
      padding: 5px;
      border-radius: 3px;
      margin-top: 10px;
      display: flex;
      &:hover {
        background: #3e3e3e;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/scoreDetail.vue